const PhonePatterns = [
    /^0[0-9]{9}$/,
    /^[0-9]{3}[ ]{0,1}[0-9]{7}$/,
    /\+233[ ]{0,1}[0-9]{9}$/,
    /\(\+233\)[ ]{0,1}[0-9]{9}$/,
    /\+233[ ]{0,1}[0-9]{2}[ ]{0,1}[0-9]{3}[ ]{0,1}[0-9]{4}$/
];

class Validator{

    static isPhone(value){

        for (let i = 0; i < PhonePatterns.length; i++) {
            if (value.match(PhonePatterns[i])) {
                return true;
            }
        }
    }

}

export default Validator;


// WEBPACK FOOTER //
// ./src/Common/Validator.js